import { Warning, ShieldCheck } from "@phosphor-icons/react";

export const RISK_BADGE = {
  faible: { bg: "#F0FDF4", fg: "#064E3B", label: "Risque faible" },
  standard: { bg: "#FFFBEB", fg: "#92400E", label: "Risque standard" },
  eleve: { bg: "#FEF2F2", fg: "#7F1D1D", label: "Risque élevé" },
};

function Fact({ label, children }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">{label}</div>
      <div>{children}</div>
    </div>
  );
}

function AiAnalysis({ analysis }) {
  if (analysis) {
    return <div className="doc-preview text-[11pt] whitespace-pre-wrap">{analysis}</div>;
  }
  return (
    <div className="flex items-center gap-3 text-sm text-zinc-500 py-4" data-testid="lcbft-analyzing">
      <span className="inline-block w-4 h-4 border-2 border-zinc-300 border-t-zinc-900 rounded-full animate-spin"></span>
      Analyse IA en cours — le rapport apparaîtra automatiquement…
    </div>
  );
}

/** Détail d'une évaluation LCB-FT : badge de risque, faits, analyse IA. */
export function LcbFtDetail({ selected, clientMap }) {
  if (!selected) {
    return <div className="border border-dashed border-zinc-300 rounded-md p-12 text-center text-zinc-500 text-sm">Sélectionnez une évaluation ou créez-en une nouvelle.</div>;
  }
  const b = RISK_BADGE[selected.risk_level] || RISK_BADGE.standard;
  const Icon = selected.risk_level === "eleve" ? Warning : ShieldCheck;
  return (
    <div className="space-y-4">
      <div className="border border-zinc-200 bg-white p-6 rounded-md">
        <div className="flex flex-wrap items-center gap-3 justify-between">
          <div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500">Client évalué</div>
            <h2 className="font-serif-display text-3xl">{clientMap[selected.client_id]?.name || "—"}</h2>
          </div>
          <div className="flex items-center gap-2 px-3 py-2 rounded-md" style={{ background: b.bg, color: b.fg }}>
            <Icon size={20} weight="fill" />
            <span className="font-medium text-sm">{b.label}</span>
          </div>
        </div>
        <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
          <Fact label="BE identifiés">{selected.beneficial_owners_identified ? "Oui" : "Non"}</Fact>
          <Fact label="Pièces d'identité">{selected.id_documents_collected ? "Oui" : "Non"}</Fact>
          <Fact label="PPE">{selected.pep_status ? "Oui" : "Non"}</Fact>
          <Fact label="Sanctions">{selected.sanctions_check ? "Vérifié" : "Non"}</Fact>
          <Fact label="Risque secteur"><span className="capitalize">{selected.activity_sector_risk}</span></Fact>
          <Fact label="Risque géo"><span className="capitalize">{selected.geographic_risk}</span></Fact>
          <Fact label="Espèces">{selected.cash_intensive ? "Oui" : "Non"}</Fact>
          <Fact label="Structure complexe">{selected.complex_structure ? "Oui" : "Non"}</Fact>
        </div>
      </div>

      <div className="border border-zinc-200 bg-white p-6 rounded-md">
        <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mb-3">Analyse IA & diligences recommandées</div>
        <AiAnalysis analysis={selected.ai_analysis} />
      </div>
    </div>
  );
}
